import { GUDHUB_SETTINGS } from '../../config.js';
require('../../core/localizationService/localizationService.js');

angular.module('reposTableModule', ['localizationModule'])

    .service('RepositoriesService', [function () {
        const getToken = async function () {
            return gudhub.getToken();
        };

        const request = async function (url, options = {}) {
            const token = await getToken();
            options.headers = {
                ...options.headers,
                'Authorization': token,
                'Content-Type': 'application/json'
            };
            const response = await fetch(url, options);
            return response.json();
        };

        this.getList = function () {
            const url = `${GUDHUB_SETTINGS.git_server_url}/get-repos`;
            return request(url);
        };

        this.create = function (name, type, description = '') {
            const url = `${GUDHUB_SETTINGS.git_server_url}/create-repo`;
            return request(url, {
                method: 'POST',
                body: JSON.stringify({ repo_name: name, repo_type: type, description })
            });
        };

        this.update = function (repoId, data) {
            const url = `${GUDHUB_SETTINGS.git_server_url}/update-repo`;
            return request(url, {
                method: 'POST',
                body: JSON.stringify({ repo_id: repoId, ...data })
            });
        };

        this.delete = function (repoId) {
            const url = `${GUDHUB_SETTINGS.git_server_url}/delete-repo`;
            return request(url, {
                method: 'POST',
                body: JSON.stringify({ repo_id: repoId })
            });
        };

        this.getRepoTypeLabel = function (type) {
            const labels = {
                'skills': 'Skills',
                'apps': 'Apps'
            };
            return labels[type] || type;
        };
    }])

    .service('SshKeysService', [function () {
        const getToken = async function () {
            return gudhub.getToken();
        };

        const request = async function (url, options = {}) {
            const token = await getToken();
            options.headers = {
                ...options.headers,
                'Authorization': token,
                'Content-Type': 'application/json'
            };
            const response = await fetch(url, options);
            return response.json();
        };

        this.getList = function () {
            const url = `${GUDHUB_SETTINGS.git_server_url}/get-ssh-keys`;
            return request(url);
        };

        this.create = function (name, publicKey) {
            const url = `${GUDHUB_SETTINGS.git_server_url}/create-ssh-key`;
            return request(url, {
                method: 'POST',
                body: JSON.stringify({ name, public_ssh_key: publicKey })
            });
        };

        this.delete = function (keyId) {
            const url = `${GUDHUB_SETTINGS.git_server_url}/delete-ssh-key`;
            return request(url, {
                method: 'POST',
                body: JSON.stringify({ key_id: keyId })
            });
        };
    }]);
